import Vue from "vue";
import Main from "./index.vue";

/**
 * 使用extend方法构建constructor动态创建组件
 */
const UploadConstructor = Vue.extend(Main);

let instance;
const Upload = (options = {}) =>
  new Promise((resolve, reject) => {
    if (instance && !instance._isDestroyed) {
      instance.destroyElement();
    }
    instance = new UploadConstructor({
      data: {
        ...options,
        resolve,
        reject
      }
    });
    instance.$mount();
    document.body.appendChild(instance.$el);
  });
export default Upload;
